import { createI18n } from "vue-i18n/index";

const messages = {
  en: {
    dashboard: "Dashboard",
    layoutBuilder: "Layout builder",
    craft: "Crafted",
    pages: "Pages",
    profile: "Profile",
    profileOverview: "Overview",
    projects: "Projects",
    campaigns: "Campaigns",
    documents: "Documents",
    connections: "Connections",
    wizards: "Wizards",
    horizontal: "Horizontal",
    vertical: "Vertical",
    account: "Account",
    accountOverview: "Overview",
    settings: "Settings",
    authentication: "Authentication",
    basicFlow: "Basic Flow",
    signIn: "Sign-in",
    signUp: "Sign-up",
    signOut: "Sign Out",
    passwordReset: "Password Reset",
    error404: "Error 404",
    error500: "Error 500",
    apps: "Apps",
    chat: "Chat",
    privateChat: "Private Chat",
    groupChat: "Group Chat",
    drawerChat: "Drawer Chat",
    widgets: "Widgets",
    widgetsLists: "Lists",
    widgetsStatistics: "Statistics",
    widgetsCharts: "Charts",
    widgetsMixed: "Mixed",
    widgetsTables: "Tables",
    widgetsFeeds: "Feeds",
    changelog: "Changelog",
    docsAndComponents: "Docs & Components",
    megaMenu: "Mega Menu",
    exampleLink: "Example link",
    modals: "Modals",
    general: "General",
    inviteFriends: "Invite Friends",
    viewUsers: "View Users",
    upgradePlan: "Upgrade Plan",
    shareAndEarn: "Share & Earn",
    forms: "Forms",
    newTarget: "New Target",
    newCard: "New Card",
    newAddress: "New Address",
    createAPIKey: "Create API Key",
    twoFactorAuth: "Two Factor Auth",
    createApp: "Create App",
    createAccount: "Create Account",
    documentation: "Documentation",
    components: "Components",
    resources: "Resources",
    activity: "Activity",
    customers: "Customers",
    gettingStarted: "Getting Started",
    customersListing: "Customers Listing",
    customerDetails: "Customers Details",
    calendarApp: "Calendar",
    subscriptions: "Subscriptions",
    getStarted: "Getting Started",
    subscriptionList: "Subscription List",
    addSubscription: "Add Subscription",
    viewSubscription: "View Subscription",
    terms: "Terms & Conditions",
    download: "Download",
    back: "Back",
    close: "Close",
    add: "Add",
    update: "Update",
    search: "Search",
    save: "Save",
    typeDocument: "Document type",
    nroDocument: "Document number",
    cancel: "Cancel",
    viewInfo: "View info",
    viewFile: "View file",
    place: "Place",
    date: "Date",
    modality: "Modality",
    home: "Home",
    sports: "Sports",
    categorie: "Category",
    male: "Male",
    female: "Female",
    notFoundResult: "No results found",
    documentAsociated: "Associated documents",
    available: "available",
    tryAgain: "Try again",
    details: "Details",
    events: "Events",
    subEvents: "Explore and participate in a wide variety of sporting events",
    save1: "Save and send",
    save2: "Save as draft",
    qtitle1: "Athletes by discipline",
    qtitle1Des: "Record the number of athletes for each sport discipline, according to the corresponding category.",
    qtitle2: "Officers by discipline",
    qtitle2Des: "Enter the number of technical officials for each sports discipline, according to the corresponding category",
    qtitle9: "General officers",
    qtitle9Des: "Please complete the following table indicating the total number of officials in your delegation",
    totalOfficer1: "Total officers per sport",
    totalOfficer2: "Total number of officers in the delegation",
    totalOfficer3: "Total of officers",
    sportSubtitle: "Complete the registration for nominal participation",
    complete: "Complete",
    bygender: "By gender",
    nusf: "Name of the NUSF",
    country:"Country",
    address: "Address",
    city: "City",
    postalCode: "Postal Code",
    telephones: "Telephones",
    nusf1: "National University Sports Federation - NUSF",
    oficine: "Office",
    mobile: "Mobile",
    Countrycallingcode: "Country calling code",
    function: "Function",
    gender: "Sex",
    GivenName: "Given Name",
    FamilyName: "Family Name",
    ContactPerson: "Contact Person",
    qtitle3: "Select the disciplines in which you participate",
    qtitle4: "Participation in the event",
    days: "Days",
    hours: "Hours",
    minutes: "Minutes",
    seconds: "Seconds",
    selection: "Select a participant for",
    document: "Document",
    participant: "Participant",
    age: "Age",
    select: "Select",
    register: "Register",
    state: "State",
    registered: "Registered",
    upload: "Upload",
    files: "Files",
    uploaded: "Uploaded",
    up1: "Select a file type",
    up2: "allowed PDF files with a size of less than 500KB.",
    up3: "Drop the file here or click to upload",
    empty: "No information to display",
    next: "Next",
    acrd0: "Academic",
    acrd1: "Academic information",
    acrd2: "Competition information",
    acrd3: "Shirt number",
    acrd4: "Playing position",
    acrd5: "Condition",
    acrd6: "University",
    acrd7: "Technical information",
    acrd8: "Role to be performed",
    acrd9: "Participation summary",
    acrd10: "Summary by Record Type",
    acrd11:"Registrations completed",
    acrd12: "Total participation",
    edit: "Edit",
    delete: "Delete",
    deleteRecord: "Delete record",
    deleteText: 'Do you want to permanently delete the record <b>{text}</b>?',
    deleteRecord2: "¿Do you want to remove the participant", 
    deleteRecord3: "of the spreadsheet?",
    finalizar: "End",
    home1: "What would you like to see?",
    home2: "Choose the option that best suits your requirements",
    home3:"Form (Long List)",
    home4:"Here you can register your entire list of participants for the different events",
    home5:"Participate in events (Accreditation)",
    home6:"Here you can register athletes and officials",
    home7:"Tutorials",
    home8:"Here you will find a series of videos or manuals regarding the accreditation system",
    clickHere: "Click here",
    birthday:"Date of birth",
    options: "Options",
    moreDetails: "More details",
    updateInformation: "Update information",
    sendInformation: "Send information",
    planilla1: "To request information review, you need to select only records whose <b>statuses are Draft</b> or <b>Observed</b>!",
    periodo: "period",
    personalData: "Personal data",
    photography: "Photography",
    remarks: "Remarks",
    preview: "Preview",
    photoHistory: "Photo History",
    recommendations: "Recommendations",
    photo1:"Passport-size photo with white background",
    photo2:"Format *.png | *jpg",
    photo3:"Maximum weight 500 Kb",
    person1: "Personal Information",
    person2: "ID",
    person3: "First surname",
    person4: "Second surname",
    person5: "Ubigeo Information",
    person6: "Contact Information",
    person7: "Additional information",
    person8: "Blood type",
    person9: "Stature",
    person10: "Reference weight",
    person11: "Allergies",
    person12: "Type of power supply",
    person13: "Name",
    person14: "Severity",
    person15: "Reactions",
    obligatorie: "Required field",
    seleccione: "- Select -",
    dateEnd: "ends the",
    competence: "Competence",
    tests: "Tests",
    numberPermited: "Number allowed must be between",
    numberExced: "Number allowed not to exceed",
    idfiba: "ID FIBA",
    institution: "Institution",
    all: "All",
    setting: "Setting",
    name: "Name",
    ambit: "Ambit",
    archive: "Archive",
    role: "Role",
    dateStart: "Date Start",
    yes: "Yes",
    permanently: "Permanently",
    representatives: "Representatives",
    users: "Users",
    image: "Image",
    itinerary: "Itinerary",
    removebackground: "Improve",
    active: "Active",
    inactive: "Inactive",
    byUpdate: 'Last update by <b>{user}</b> the {date}',
    acronym: "Acronym",
    acronymText: '{text} (max {max} characters)',
    english: "English",
    espaniol: "Spanish",
    nameIn: 'Name in {idioma}',
    tipo: "Type",
    sede: "Seat",
    urlFriendly: "Friendly URL",
    yearMax: "Maximum allowed year",
    yearMin: "Minimum allowed year",
    enterToNumber: "Enter a number",
    activeForms: "Enable forms",
    activeRegister: "Enable registrations",
    private: "Private",
    public: "Public",
    asigned: "Asigned",
    moreInformation: "More Information",
    eventData: "Event Data",
    username: "Username",
    attendees: "Attendees",
    afiliations: "Affiliations",
    labelDeadLine: "Registrations end on",
    notice: "Notice",
    toRelease: "To release",
    fileViewer: "File Viewer",
    selectedTest: "Selected tests",
    zone: "Zone",
    flightnumber: "Flight number",
    aerolinea: "Name of the airline",
    arrivaltime: "Arrival Time",
    arrivaldate: "Arrival date",
    departuretime: "Departure time",
    departuredate: "Departure date",
    nameTeam: "Team name",
    nameShort: "Short name",
    shirtColor: "Primary t-shirt color",
    secondColor: "Secondary t-shirt color",
    registerTeam: "Register team",
    editTeam: "Edit team",
    deleteTeam: "Delete team",
    size: "Size",
    weresorry: "We're sorry!"
  },
  es: {
    dashboard: "Tablero",
    layoutBuilder: "Constructor de maquetación",
    craft: "Elaborado",
    pages: "Paginas",
    profile: "Perfil",
    profileOverview: "Descripción general",
    projects: "Proyectos",
    campaigns: "Campañas",
    documents: "Documentos",
    connections: "Conexiones",
    wizards: "Magos",
    horizontal: "Horizontal",
    vertical: "Vertical",
    account: "Cuenta",
    accountOverview: "Descripción general",
    settings: "Ajustes",
    authentication: "Autenticación",
    basicFlow: "Flujo básico",
    signIn: "Registrarse",
    signUp: "Inscribirse",
    signOut: "Cerrar sesión",
    passwordReset: "Restablecimiento de contraseña",
    error404: "Error 404",
    error500: "Error 500",
    apps: "Aplicaciones",
    chat: "Chat",
    privateChat: "Chat privado",
    groupChat: "Grupo de chat",
    drawerChat: "Chat del cajón",
    widgets: "Widgets",
    widgetsLists: "Liza",
    widgetsStatistics: "Estadísticas",
    widgetsCharts: "Gráficos",
    widgetsMixed: "Mezclada",
    widgetsTables: "Mesas",
    widgetsFeeds: "Alimenta",
    changelog: "Registro de cambios",
    docsAndComponents: "Documentos & Componentes",
    megaMenu: "Mega menú",
    exampleLink: "Enlace de ejemplo",
    modals: "Modales",
    general: "General",
    inviteFriends: "Invitar A Amigos",
    viewUsers: "Ver Usuarios",
    upgradePlan: "Plan De Actualización",
    shareAndEarn: "Compartir Y Ganar",
    forms: "Formularios",
    newTarget: "Nuevo Objetivo",
    newCard: "Nueva Tarjeta",
    newAddress: "Nueva Direccion",
    createAPIKey: "Crea Clave De Api",
    twoFactorAuth: "Dos Factores",
    createApp: "Crear Aplicacion",
    createAccount: "Crear Una Cuenta",
    activity: "Actividad",
    documentation: "Documentación",
    components: "Componentes",
    resources: "Recursos",
    customers: "Clientes",
    gettingStarted: "Empezando",
    customersListing: "Listado De Clientes",
    customerDetails: "Detalles De Los Clientes",
    calendarApp: "Calendario",
    subscriptions: "Suscripciones",
    getStarted: "Empezando",
    subscriptionList: "Lista De Suscripción",
    addSubscription: "Añadir Suscripción",
    viewSubscription: "Suscripción",
    terms: "Terminos y condiciones",
    download: "Descargar",
    back: "Atrás",
    close: "Cerrar",
    add: "Agregar",
    update: "Actualizar",
    search: "Buscar",
    save: "Guardar",
    typeDocument: "Tipo de documento",
    nroDocument: "Nro. de documento",
    cancel: "Cancelar",
    viewInfo: "Ver información",
    viewFile: "Ver archivo",
    place: "Lugar",
    date: "Fecha",
    modality: "Modalidad",
    home: "Inicio",
    sports: "Deportes",
    categorie: "Categoría",
    male: "Masculino",
    female: "Femenino",
    notFoundResult: "No se encontrarón resultados",
    documentAsociated: "Documentos asociados",
    available: "Disponibles",
    tryAgain: "Volver a intentar",
    details: "Detalles",
    events: "Eventos",
    subEvents: "Explora y participa en una amplia variedad de eventos deportivos",
    save1: "Guardar y enviar",
    save2: "Guardar como borrador",
    qtitle1: "Atletas por disciplina",
    qtitle1Des: "Ingrese la cantidad de atletas por cada disciplina deportiva, de acuerdo con la categoría que corresponda.",
    qtitle2: "Oficiales por disciplina​",
    qtitle2Des: "Ingrese la cantidad de oficiales técnicos por cada disciplina deportiva, de acuerdo con la categoría que corresponda",
    qtitle9: "Oficiales generales​",
    qtitle9Des: "Sírvase completar el siguiente cuadro indicando el número total de funcionarios de su delegación",
    totalOfficer1: "Total de oficiales por deporte",
    totalOfficer2: "Total de oficiales de la delegación",
    totalOfficer3: "Total de oficiales",
    sportSubtitle:"Completa el registro para la participación nominal",
    complete: "Completar",
    bygender: "Por género",
    nusf: "Nombre de la NUSF",
    country: "País",
    address: "Dirección",
    city: "Ciudad",
    postalCode: "Código Postal",
    telephones: "Teléfonos",
    nusf1: "Federación Nacional de Deportes Universitarios - NUSF",
    oficine: "Oficina",
    mobile: "Móvil",
    Countrycallingcode: "Código del país",
    function: "Función",
    gender: "Sexo",
    GivenName: "Apellidos completos",
    FamilyName: "Nombres completos",
    ContactPerson: "Persona de contacto",
    qtitle3:"Seleccione las disciplinas en las que participa",
    qtitle4: "Participación en el evento",
    days: "Dias",
    hours: "Horas",
    minutes: "Minutos",
    seconds: "Segundos",
    selection: "seleccione un participante para",
    document: "Documento",
    participant: "Participante",
    age: "Edad",
    select: "Seleccione",
    register: "Registrar",
    state: "Estado",
    registered: "Registrado",
    upload: "Subir",
    files: "Archivos",
    uploaded: "subidos",
    up1: "Selecciona un tipo de archivo",
    up2: "archivos permitidos PDF con un tamaño menor a 500KB.",
    up3: "Suelte el archivo aquí o haga clic para cargar",
    empty: "No hay información para mostrar",
    next: "Siguiente",
    acrd0: "Academico",
    acrd1: "Información académica",
    acrd2: "Información de competencia",
    acrd3: "Nro. de camiseta",
    acrd4: "Posición de juego",
    acrd5: "Condición",
    acrd6: "Universidad",
    acrd7: "Información técnica",
    acrd8: "Función a desempeñar",
    acrd9: "Resumen de participación",
    acrd10: "Resumen por tipo de registro",
    acrd11: "Inscripciones finalizadas",
    acrd12: "Participación total",
    edit: "Editar",
    delete: "Eliminar",
    deleteRecord: "Eliminar registro",
    deleteText: '¿Desea eliminar el registro <b>{text}</b> de manera permanente?',
    deleteRecord2: "¿Desea eliminar al participante", 
    deleteRecord3: "de la planilla?",
    finalizar: "Finalizar",
    home1: "¿Qué te gustaría ver?",
    home2: "Elige la opción que mejor se adapte a tus requerimientos",
    home3:"Planilla (Lista Larga)",
    home4:"Aquí podras registrar a toda tu lista de participantes a los distintos eventos",
    home5:"Participar en eventos (Acreditación)",
    home6:"Aquí podras registrar a deportitas y oficiales",
    home7:"Tutoriales",
    home8:"Aquí encontrarás una sería de videos o manuales referente al sistema de acreditación",
    clickHere: "Clic aquí",
    birthday: "F. nacimiento",
    options: "Opciones",
    moreDetails: "Más detalles",
    updateInformation: "Actualizar información",
    sendInformation: "Enviar información",
    planilla1: "Para solicitar la revisión de información, necesita seleccionar solo los registros cuyos estados sean <b>Borrador</b> u <b>Observado</b>!",
    periodo: "Periodo",
    personalData: "Datos personales",
    photography: "Fotografía",
    remarks: "Observaciones",
    preview: "Vista previa",
    photoHistory: "Historial de fotos",
    recommendations: "Recomendaciones",
    photo1:"Foto tamaño carnet con fondo blanco",
    photo2:"Formato *.png | *jpg",
    photo3:"Peso máximo 500 Kb",
    person1: "Información personal",
    person2: "Código",
    person3: "Primer apellido",
    person4: "Segundo apellido",
    person5: "Información de úbigeo",
    person6: "Información de contacto",
    person7: "Información adicional",
    person8: "Tipo de sangre",
    person9: "Estatura",
    person10: "Peso referencial",
    person11: "Alergias",
    person12: "Tipo de alimentación",
    person13: "Nombre", 
    person14: "Severidad",
    person15: "Reacciones",
    obligatorie: "Campo obligatorio",
    seleccione: "- Seleccione -",
    dateEnd: "Finaliza el",
    competence: "Competencia",
    tests: "Pruebas",
    numberPermited: "Número permitido debe ser entre",
    numberExced: "Número permitido no mayor a",
    idfiba: "ID FIBA",
    institution: "Institución",
    all: "Todos",
    setting: "Configurar",
    name: "Nombre",
    ambit: "Ámbito",
    archive: "Archivar",
    role: "Función",
    dateStart: "Fecha de inicio",
    yes: "SI",
    permanently: "de forma permanente",
    representatives: "Representantes",
    users: "Usuarios",
    image: "Image",
    itinerary: "Itinerario",
    removebackground: "Mejorar",
    active: "Activo",
    inactive: "Inactivo",
    byUpdate: 'última actualización por <b>{user}</b> el {date}',
    acronym: "Siglas",
    acronymText: '{text} (max {max} caracteres)',
    english: "Ingles",
    espaniol: "Español",
    nameIn: 'Nombre en {idioma}',
    tipo: "Tipo",
    sede: "Sede",
    urlFriendly:"URL amigable",
    yearMax: "Año máximo permitido",
    yearMin: "Año mínimo permitido",
    enterToNumber: "Ingrese un número",
    activeForms: "Habilitar formularios",
    activeRegister: "Habilitar inscripciones",
    private: "Privado",
    public: "Publico",
    asigned: "Asignados",
    moreInformation: "Más información",
    eventData: "Datos del evento",
    username: "Nombre de usuario",
    attendees: "Asistentes",
    afiliations: "Afiliaciones",
    labelDeadLine:"Las inscripciones finalizan en",
    notice:"Aviso",
    toRelease: "Liberar",
    fileViewer: "Visor de archivos",
    selectedTest: "Pruebas seleccionadas",
    zone: "Zona",
    flightnumber: "Nro. de vuelo",
    aerolinea: "Nombre de la aerolinea",
    arrivaltime: "Hora de llegada",
    arrivaldate: "Fecha de llegada",
    departuretime: "Hora de salida",
    departuredate: "Fecha de salida",
    nameTeam: "Nombre del equipo",
    nameShort: "Nombre corto",
    shirtColor: "Color de camiseta primario",
    secondColor: "Color de camiseta secundario",
    registerTeam: "Registrar equipo",
    editTeam: "Editar equipo",
    deleteTeam: "Eliminar equipo",
    size: "Tamaño",
    weresorry: "!Lo sentimos¡"
  },
  de: {
    dashboard: "Instrumententafel",
    layoutBuilder: "Layout-Builder",
    craft: "Hergestellt",
    pages: "Seiten",
    profile: "Profil",
    profileOverview: "Überblick",
    projects: "Projekte",
    campaigns: "Kampagnen",
    documents: "Unterlagen",
    connections: "Anschlüsse",
    wizards: "Zauberer",
    horizontal: "Horizontal",
    vertical: "Vertikal",
    account: "Konto",
    accountOverview: "Überblick",
    settings: "Die Einstellungen",
    authentication: "Authentifizierung",
    basicFlow: "Grundfluss",
    signIn: "Einloggen",
    signUp: "Anmelden",
    passwordReset: "Passwort zurücksetzen",
    error404: "Fehler 404",
    error500: "Fehler 500",
    apps: "Apps",
    chat: "Plaudern",
    privateChat: "Private Chat",
    groupChat: "Privater Chat",
    drawerChat: "Gruppenchat Schubladen-Chat",
    widgets: "Widgets",
    widgetsLists: "Listen",
    widgetsStatistics: "Statistiken",
    widgetsCharts: "Diagramme",
    widgetsMixed: "Gemischt",
    widgetsTables: "Tabellen",
    widgetsFeeds: "Einspeisungen",
    changelog: "Änderungsprotokoll",
    docsAndComponents: "Dokumente & Komponenten",
    megaMenu: "Mega-Menü",
    exampleLink: "Beispiellink",
    modals: "Modale",
    general: "Allgemeines",
    inviteFriends: "Freunde Einladen",
    viewUsers: "Benutzer Anzeigen.",
    upgradePlan: "Upgrade-Plan",
    shareAndEarn: "Teilen & Verdienen",
    forms: "Formen",
    newTarget: "Neues Ziel",
    newCard: "Neue Karte",
    newAddress: "Neue Adresse",
    createAPIKey: "Api-Key Erstellen",
    twoFactorAuth: "Zwei Faktor Auth.",
    createApp: "App Erstellen",
    createAccount: "Benutzerkonto Erstellen",
    activity: "Aktivität",
    documentation: "Dokumentation",
    components: "Bauteile",
    resources: "Ressourcen",
    customers: "Kunden",
    gettingStarted: "Einstieg",
    customersListing: "Kundenauflistung",
    customerDetails: "Kundenangaben",
    calendarApp: "Kalender",
    subscriptions: "Abonnements",
    getStarted: "Einstieg",
    subscriptionList: "Abonnementliste",
    addSubscription: "Subskription Hinzufügen.",
    viewSubscription: "Abonnement Anzeigen.",
    terms: "Allgemeine Geschäftsbedingungen (AGB)",
    download: "herunterladen",
    back: "Zurück",
    close: "schließen"
  },
  ja: {
    dashboard: "ダッシュボード",
    layoutBuilder: "レイアウトビルダー",
    craft: "作成された",
    pages: "ページ",
    profile: "プロフィール",
    profileOverview: "概要",
    projects: "プロジェクト",
    campaigns: "キャンペーン",
    documents: "書類",
    connections: "接続",
    wizards: "ウィザード",
    horizontal: "横",
    vertical: "垂直",
    account: "アカウント",
    accountOverview: "概要",
    settings: "設定",
    authentication: "認証",
    basicFlow: "基本的な流れ",
    signIn: "サインイン",
    signUp: "サインアップ",
    passwordReset: "パスワードのリセット",
    error404: "エラー404",
    error500: "エラー 500",
    apps: "アプリ",
    chat: "チャット",
    privateChat: "プライベートチャット",
    groupChat: "グループチャット",
    drawerChat: "ドロワーチャット",
    widgets: "ウィジェット",
    widgetsLists: "リスト",
    widgetsStatistics: "統計",
    widgetsCharts: "チャート",
    widgetsMixed: "混合",
    widgetsTables: "テーブル",
    widgetsFeeds: "フィード",
    changelog: "変更ログ",
    docsAndComponents: "ドキュメントとコンポーネント",
    megaMenu: "メガメニュー",
    exampleLink: "リンク例",
    modals: "モーダルズ",
    general: "一般",
    inviteFriends: "友達を招待",
    viewUsers: "ユーザーを表示します",
    upgradePlan: "アップグレードプラン",
    shareAndEarn: "シェア＆稼働",
    forms: "フォーム",
    newTarget: "新しいターゲット",
    newCard: "新しいカード",
    newAddress: "新しいアドレス",
    createAPIKey: "Apiキーを作成します",
    twoFactorAuth: "2つの要因Auth",
    createApp: "アプリを作成します",
    createAccount: "アカウントを作成する",
    activity: "アクティビティ",
    documentation: "ドキュメンテーション",
    components: "コンポーネント",
    resources: "資力",
    customers: "お客様のお客様",
    gettingStarted: "入門",
    customersListing: "顧客のリスト",
    customerDetails: "お客様の詳細",
    calendarApp: "カレンダー",
    subscriptions: "購読",
    getStarted: "入門",
    subscriptionList: "サブスクリプションリスト",
    addSubscription: "サブスクリプションを追加します",
    viewSubscription: "購読を見る",
    terms: "規約と条件",
    download: "ダウンロード",
    back: "戻る",
    close: "閉める"
  },
  fr: {
    dashboard: "Générateur de mise",
    layoutBuilder: "En page",
    craft: "Fabriqué",
    pages: "Pages",
    profile: "Profil",
    profileOverview: "Aperçu",
    projects: "Projets",
    campaigns: "Campagnes",
    documents: "Documents",
    connections: "Connexions",
    wizards: "Sorciers",
    horizontal: "Horizontal",
    vertical: "Verticale",
    account: "Compte",
    accountOverview: "Aperçu",
    settings: "Paramètres",
    authentication: "Authentification",
    basicFlow: "Flux de base",
    signIn: "SS'identifier",
    signUp: "Inscrivez-vous",
    passwordReset: "Réinitialisation du mot de passe",
    error404: "Erreur 404",
    error500: "Erreur 500",
    apps: "Applications",
    chat: "Discuter",
    privateChat: "Discussion privée",
    groupChat: "Discussion de groupe",
    drawerChat: "Chat de tiroir",
    widgets: "Widgets",
    widgetsLists: "Listes",
    widgetsStatistics: "Statistiques",
    widgetsCharts: "Graphiques",
    widgetsMixed: "Mixte",
    widgetsTables: "Les tables",
    widgetsFeeds: "Flux",
    changelog: "Journal des modifications",
    docsAndComponents: "Documents & composants",
    megaMenu: "Méga Menu",
    exampleLink: "Exemple de lien",
    modals: "Modals",
    general: "Général",
    inviteFriends: "Inviter Des Amis",
    viewUsers: "Voir Les Utilisateurs",
    upgradePlan: "Plan De Mise À Niveau",
    shareAndEarn: "Partager Et Gagner",
    forms: "Formes",
    newTarget: "Nouvelle Cible",
    newCard: "Nouvelle Carte",
    newAddress: "Nouvelle Adresse",
    createAPIKey: "Créer Une Touche Api",
    twoFactorAuth: "Deux Facteurs D'Authentification",
    createApp: "Créer Une Application",
    createAccount: "Créer Un Compte",
    activity: "Activité",
    documentation: "Documentation",
    components: "Composants",
    resources: "Ressources",
    customers: "Les Clients",
    gettingStarted: "Commencer",
    customersListing: "Liste Des Clients",
    customerDetails: "Détails Des Clients",
    calendarApp: "Calendrier",
    subscriptions: "Abonnements",
    getStarted: "Commencer",
    subscriptionList: "Liste D'Abonnement",
    addSubscription: "Ajouter Un Abonnement",
    viewSubscription: "Voir L'Abonnement",
    terms: "Termes et conditions",
    download: "Télécharger",
    back: "Derrière",
    close: "fermer",
  },
};

const i18n = createI18n({
  legacy: false,
  locale: "en",
  globalInjection: true,
  messages,
});

export default i18n;
